var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("requests-edit-table", {
    attrs: {
      requests: _vm.requests,
      options: _vm.options,
      "group-by": "order",
    },
    on: { change: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }